import React, { Component } from 'react'
import { Button, Popconfirm } from 'antd'
import { DebounceInput } from 'react-debounce-input'

const ButtonGroup = Button.Group

class ProposalSectionLine extends Component {
  renderItem = (milestone, index) => {
    const {
      moveMilestoneUp,
      moveMilestoneDown,
      disableMoveItemDown,
      disableMoveItemUp,
      handleDeleteMilestone,
      handleMilestoneChange
    } = this.props

    return (
      milestone &&
      !milestone.markedForDeletion && (
        <div className="row padding10" key={index}>
          <div className="col-md-9">
            <DebounceInput
              className="ant-input"
              minLength={0}
              debounceTimeout={500}
              value={milestone.description ? milestone.description : ''}
              onChange={e => handleMilestoneChange(e.target.value, index)}
              name="description"
            />
          </div>
          <div className="col-md-3 text-right">
            <ButtonGroup>
              <Button
                disabled={disableMoveItemUp}
                icon="caret-up"
                onClick={() => moveMilestoneUp(index)}
              />
              <Button
                disabled={disableMoveItemDown}
                icon="caret-down"
                onClick={() => moveMilestoneDown(index)}
              />
              <Popconfirm
                title="Are you sure you want to delete this line?"
                onConfirm={() => handleDeleteMilestone(index)}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger" icon="delete" />
              </Popconfirm>
            </ButtonGroup>
          </div>
        </div>
      )
    )
  }

  render() {
    const { milestone, index } = this.props

    if (milestone) {
      return this.renderItem(milestone, index)
    } else {
      return <ol>loading...</ol>
    }
  }
}

export default ProposalSectionLine



// WEBPACK FOOTER //
// ./src/components/proposal/ProposalMilestone.js